import { type ConditionalFormattingColorValue } from './ConditionalFormattingCategoryColor';
import CategoryColor from 'owa-categories/lib/store/schema/CategoryColor';

export const lightColorCodeValueMap: {
    [color: string]: ConditionalFormattingColorValue;
} = {
    [CategoryColor.None]: {
        restColor: 'transparent',
        primaryColor: '#d1d1d1',
        buttonColor: '#d1d1d1',
        iconColor: '#242424',
        textColor: '#424242',
        hoverColor: '#f5f5f5',
        activeColor: 'transparent',
        disabledColor: '#f5f5f5',
        disabledTextColor: '#d1d1d1',
        disabledIconColor: '#d1d1d1',
    },

    [CategoryColor.DarkRed]: {
        restColor: '#F3E2E5',
        primaryColor: '#AC4F5E',
        buttonColor: '#AC4F5E',
        iconColor: '#750B1C',
        textColor: '#420610',
        hoverColor: '#E9C7CD',
        activeColor: '#D69CA5',
        textSelectedHoverColor: '#130204',
    },

    [CategoryColor.Cranberry]: {
        restColor: '#FAE7E9',
        primaryColor: '#DC626D',
        buttonColor: '#DC626D',
        iconColor: '#C50F1F',
        textColor: '#6E0811',
        hoverColor: '#F6D1D5',
        activeColor: '#EEACB2',
        textSelectedHoverColor: '#200205',
    },

    [CategoryColor.DarkOrange]: {
        restColor: '#F9DCD1',
        primaryColor: '#E9835E',
        buttonColor: '#E9835E',
        iconColor: '#C43501',
        textColor: '#7A2101',
        hoverColor: '#F4BFAB',
        activeColor: '#DA3B01',
    },

    [CategoryColor.Bronze]: {
        restColor: '#F1D9CC',
        primaryColor: '#CA8057',
        buttonColor: '#CA8057',
        iconColor: '#A74109',
        textColor: '#5E2405',
        hoverColor: '#E5BBA4',
        activeColor: '#A74109',
    },

    [CategoryColor.Peach]: {
        restColor: '#FFF5EA',
        primaryColor: '#FFBA66',
        buttonColor: '#FFBA66',
        iconColor: '#8F4E00',
        textColor: '#4D2A00',
        hoverColor: '#FFEDD6',
        activeColor: '#FFDDB3',
        textSelectedHoverColor: '#291600',
    },

    [CategoryColor.Marigold]: {
        restColor: '#FDF6E8',
        primaryColor: '#F2C661',
        buttonColor: '#F2C661',
        iconColor: '#835B00',
        textColor: '#463100',
        hoverColor: '#FCEFD3',
        activeColor: '#F9E2AE',
        textSelectedHoverColor: '#251A00',
    },

    [CategoryColor.Gold]: {
        restColor: '#F5EECE',
        primaryColor: '#DAC157',
        buttonColor: '#DAC157',
        iconColor: '#6C5700',
        textColor: '#3A2F00',
        hoverColor: '#DAC157',
        activeColor: '#C19C00',
    },

    [CategoryColor.DarkBrown]: {
        restColor: '#CAADA3',
        primaryColor: '#946B5C',
        buttonColor: '#946B5C',
        iconColor: '#4D291C',
        textColor: '#2B1710',
        hoverColor: '#E3D2CB',
        activeColor: '#4D291C',
    },

    [CategoryColor.Lime]: {
        restColor: '#F1F7E8',
        primaryColor: '#A4CC6C',
        buttonColor: '#A4CC6C',
        iconColor: '#405F14',
        textColor: '#22330B',
        hoverColor: '#E5F1D3',
        activeColor: '#CFE5AF',
        textSelectedHoverColor: '#121B06',
    },

    [CategoryColor.Forest]: {
        restColor: '#BDD99B',
        primaryColor: '#85B44C',
        buttonColor: '#85B44C',
        iconColor: '#294903',
        textColor: '#162702',
        hoverColor: '#85B44C',
        activeColor: '#498205',
    },

    [CategoryColor.LightGreen]: {
        restColor: '#CEF0CD',
        primaryColor: '#5EC75A',
        buttonColor: '#5EC75A',
        iconColor: '#0E7A0B',
        textColor: '#063004',
        hoverColor: '#5EC75A',
        activeColor: '#13A10E',
    },

    [CategoryColor.DarkGreen]: {
        restColor: '#E2F2E2',
        primaryColor: '#4DA64D',
        buttonColor: '#4DA64D',
        iconColor: '#085108',
        textColor: '#032003',
        hoverColor: '#C6E7C6',
        activeColor: '#9AD29A',
        textSelectedHoverColor: '#021102',
    },

    [CategoryColor.LightTeal]: {
        restColor: '#E6F8F9',
        primaryColor: '#58D3DB',
        buttonColor: '#58D3DB',
        iconColor: '#00666D',
        textColor: '#00373A',
        hoverColor: '#CEF3F5',
        activeColor: '#A6E9ED',
        textSelectedHoverColor: '#001D1F',
    },

    [CategoryColor.DarkTeal]: {
        restColor: '#92D1D1',
        primaryColor: '#41A3A3',
        buttonColor: '#41A3A3',
        iconColor: '#003939',
        textColor: '#003939',
        hoverColor: '#C2E7E7',
        activeColor: '#006666',
    },

    [CategoryColor.Steel]: {
        restColor: '#E0EFF3',
        primaryColor: '#4496A9',
        buttonColor: '#4496A9',
        iconColor: '#005B70',
        textColor: '#00333F',
        hoverColor: '#C3E1E8',
        activeColor: '#94C8D4',
        textSelectedHoverColor: '#000F12',
    },

    [CategoryColor.SkyBlue]: {
        restColor: '#E9F9FD',
        primaryColor: '#63D7F7',
        buttonColor: '#63D7F7',
        iconColor: '#006A88',
        textColor: '#004659',
        hoverColor: '#D4F4FD',
        activeColor: '#B0EBFB',
        textSelectedHoverColor: '#001C24',
    },

    [CategoryColor.DarkBlue]: {
        restColor: '#E0EAF2',
        primaryColor: '#4178A3',
        buttonColor: '#4178A3',
        iconColor: '#003966',
        textColor: '#002039',
        hoverColor: '#C2D6E7',
        activeColor: '#92B5D1',
        textSelectedHoverColor: '#00111F',
    },

    [CategoryColor.Lavender]: {
        restColor: '#F2F1FC',
        primaryColor: '#A79CF1',
        buttonColor: '#A79CF1',
        iconColor: '#6656D1',
        textColor: '#3F3682',
        hoverColor: '#E7E4FB',
        activeColor: '#D2CCF8',
        textSelectedHoverColor: '#120F25',
    },

    [CategoryColor.DarkPurple]: {
        restColor: '#D8CCE7',
        primaryColor: '#7E5CA7',
        buttonColor: '#7E5CA7',
        iconColor: '#512B7E',
        textColor: '#240F3C',
        hoverColor: '#B9A3D3',
        activeColor: '#401B6C',
    },

    [CategoryColor.Pink]: {
        restColor: '#FCEDF7',
        primaryColor: '#EF85C8',
        buttonColor: '#EF85C8',
        iconColor: '#AD2D7E',
        textColor: '#80215D',
        hoverColor: '#FBDDF0',
        activeColor: '#F7C0E3',
        textSelectedHoverColor: '#24091B',
    },

    [CategoryColor.Plum]: {
        restColor: '#F3E1ED',
        primaryColor: '#AD4589',
        buttonColor: '#AD4589',
        iconColor: '#87105D',
        textColor: '#43002B',
        hoverColor: '#E9C4DC',
        activeColor: '#D696C0',
        textSelectedHoverColor: '#13000C',
    },

    [CategoryColor.Beige]: {
        restColor: '#EAE8E8',
        primaryColor: '#AFABAA',
        buttonColor: '#AFABAA',
        iconColor: '#6E6968',
        textColor: '#444241',
        hoverColor: '#D7D4D4',
        activeColor: '#7A7574',
    },

    [CategoryColor.Mink]: {
        restColor: '#CECCCB',
        primaryColor: '#9E9B99',
        buttonColor: '#9E9B99',
        iconColor: '#474443',
        textColor: '#343231',
        hoverColor: '#9E9B99',
        activeColor: '#5D5A58',
    },

    [CategoryColor.Silver]: {
        restColor: '#F4F6F6',
        primaryColor: '#B3BFC2',
        buttonColor: '#B3BFC2',
        iconColor: '#657174',
        textColor: '#4A5356',
        hoverColor: '#EAEEEF',
        activeColor: '#D8DFE0',
        textSelectedHoverColor: '#282D2E',
    },

    [CategoryColor.Charcoal]: {
        restColor: '#EEEEEE',
        primaryColor: '#888888',
        buttonColor: '#888888',
        iconColor: '#333333',
        textColor: '#202020',
        hoverColor: '#DFDFDF',
        activeColor: '#C4C4C4',
        textSelectedHoverColor: '#090909',
    },
};
